export const categoryContent = {
  movies: {
    name: '电影',
    description: '海量院线大片与经典佳作，涵盖动作、科幻、喜剧、爱情、悬疑等多种类型',
    items: [
      {
        id: 101,
        title: '星际穿越',
        category: '科幻',
        rating: 9.4,
        year: 2014,
        image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20space%20movie%20poster%2C%20black%20hole%20and%20spaceship%20visual%2C%20deep%20space%20atmosphere%2C%20dramatic%20golden%20light%2C%20cinematic%20composition&width=600&height=800&seq=cat-movie-01&orientation=portrait',
        description: '一组太空探险者穿越虫洞，为人类寻找新家园的壮丽旅程。',
      },
      {
        id: 102,
        title: '流浪地球2',
        category: '科幻',
        rating: 9.1,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%2C%20massive%20spaceship%20engine%2C%20earth%20in%20space%2C%20blue%20and%20orange%20contrast%2C%20grand%20cinematic%20scale&width=600&height=800&seq=cat-movie-02&orientation=portrait',
        description: '太阳即将毁灭，人类在地球表面建造巨型推进器，开启长达2500年的流浪之旅。',
      },
      {
        id: 103,
        title: '长安三万里',
        category: '动画',
        rating: 9.0,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20movie%20poster%2C%20Tang%20Dynasty%20poetry%20scene%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20warm%20golden%20tones&width=600&height=800&seq=cat-movie-03&orientation=portrait',
        description: '以盛唐为背景，讲述李白与高适的传奇友谊和波澜壮阔的人生故事。',
      },
      {
        id: 104,
        title: '热辣滚烫',
        category: '喜剧',
        rating: 8.5,
        year: 2024,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20warm%20and%20inspiring%20atmosphere%2C%20boxing%20ring%20scene%2C%20soft%20peach%20and%20gold%20tones%2C%20cinematic&width=600&height=800&seq=cat-movie-04&orientation=portrait',
        description: '一个普通女孩通过拳击找到自我、实现人生逆袭的励志故事。',
      },
      {
        id: 105,
        title: '封神第一部',
        category: '奇幻',
        rating: 8.8,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%2C%20ancient%20Chinese%20mythology%2C%20warriors%20in%20armor%2C%20dramatic%20sky%20with%20thunder%2C%20epic%20scale&width=600&height=800&seq=cat-movie-05&orientation=portrait',
        description: '商王殷寿暴虐无道，姬发觉醒踏上封神之路，一场神魔大战就此展开。',
      },
      {
        id: 106,
        title: '奥本海默',
        category: '传记',
        rating: 9.2,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Biographical%20drama%20movie%20poster%2C%20nuclear%20explosion%20visual%2C%20black%20and%20white%20aesthetic%2C%20intense%20atmosphere%2C%20dramatic%20portrait%20composition&width=600&height=800&seq=cat-movie-06&orientation=portrait',
        description: '原子弹之父奥本海默的传奇人生，科学、道德与政治的深刻博弈。',
      },
      {
        id: 107,
        title: '人生大事',
        category: '剧情',
        rating: 8.7,
        year: 2022,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20movie%20poster%2C%20warm%20emotional%20scene%2C%20father%20and%20daughter%20bond%2C%20soft%20natural%20lighting%2C%20touching%20atmosphere&width=600&height=800&seq=cat-movie-07&orientation=portrait',
        description: '殡葬师莫三妹与孤儿小文的相遇，演绎了一段笑泪交织的温暖故事。',
      },
      {
        id: 108,
        title: '满江红',
        category: '悬疑',
        rating: 8.3,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%2C%20Song%20Dynasty%20courtyard%20scene%2C%20red%20lanterns%2C%20mysterious%20atmosphere%2C%20dark%20crimson%20tones&width=600&height=800&seq=cat-movie-08&orientation=portrait',
        description: '南宋年间，一场围绕岳飞遗言展开的惊心动魄的悬疑权谋故事。',
      },
    ],
  },
  tv: {
    name: '电视剧',
    description: '热门电视剧全集在线观看，国剧、韩剧、美剧、日剧应有尽有',
    items: [
      {
        id: 201,
        title: '繁花',
        category: '都市',
        rating: 9.2,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%201990s%20Shanghai%20neon%20night%20scene%2C%20nostalgic%20amber%20lighting%2C%20elegant%20Chinese%20drama%20aesthetic&width=600&height=800&seq=cat-tv-01&orientation=portrait',
        description: '九十年代的上海，阿宝在时代浪潮中浮沉，书写一段传奇商业故事。',
      },
      {
        id: 202,
        title: '梦华录',
        category: '古装',
        rating: 8.9,
        year: 2022,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20poster%2C%20Song%20Dynasty%20tea%20house%2C%20elegant%20traditional%20costume%2C%20soft%20jade%20green%20tones&width=600&height=800&seq=cat-tv-02&orientation=portrait',
        description: '三个女人在北宋东京城经历磨难与成长，携手闯出一片天地。',
      },
      {
        id: 203,
        title: '狂飙',
        category: '刑侦',
        rating: 9.3,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%2C%20police%20investigation%20scene%2C%20dark%20urban%20atmosphere%2C%20intense%20blue%20and%20red%20contrast&width=600&height=800&seq=cat-tv-03&orientation=portrait',
        description: '一场跨越二十年的正邪较量，揭露黑恶势力背后的惊人真相。',
      },
      {
        id: 204,
        title: '三体',
        category: '科幻',
        rating: 8.7,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%2C%20three%20body%20problem%20concept%2C%20cosmic%20scale%2C%20mysterious%20universe%2C%20dark%20blue%20and%20purple%20nebula&width=600&height=800&seq=cat-tv-04&orientation=portrait',
        description: '根据刘慈欣同名科幻巨著改编，人类文明与三体文明的首次接触。',
      },
      {
        id: 205,
        title: '庆余年2',
        category: '古装',
        rating: 8.6,
        year: 2024,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20costume%20drama%20poster%2C%20ancient%20palace%20intrigue%2C%20martial%20arts%20theme%2C%20rich%20red%20and%20gold%20tones&width=600&height=800&seq=cat-tv-05&orientation=portrait',
        description: '范闲回归京都，在尔虞我诈的朝堂之上展开新一轮的权谋智斗。',
      },
      {
        id: 206,
        title: '黑暗荣耀',
        category: '韩剧',
        rating: 8.9,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20poster%2C%20dark%20elegant%20atmosphere%2C%20mysterious%20woman%20portrait%2C%20cold%20and%20sharp%20visual%20style&width=600&height=800&seq=cat-tv-06&orientation=portrait',
        description: '年少遭受校园暴力的女子，精心策划了一场华丽而残酷的复仇。',
      },
      {
        id: 207,
        title: '漫长的季节',
        category: '悬疑',
        rating: 9.4,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20drama%20poster%2C%20northeastern%20China%20autumn%20scene%2C%20mysterious%20train%20track%2C%20warm%20nostalgic%20tones&width=600&height=800&seq=cat-tv-07&orientation=portrait',
        description: '一段跨越二十年的东北往事，一个父亲追寻真相的孤独旅程。',
      },
      {
        id: 208,
        title: '权力的游戏',
        category: '美剧',
        rating: 9.5,
        year: 2011,
        image: 'https://readdy.ai/api/search-image?query=Fantasy%20epic%20TV%20series%20poster%2C%20medieval%20fantasy%20world%2C%20iron%20throne%2C%20dark%20and%20cold%20atmosphere&width=600&height=800&seq=cat-tv-08&orientation=portrait',
        description: '维斯特洛大陆上，各大家族为争夺铁王座展开的血雨腥风的权力游戏。',
      },
    ],
  },
  variety: {
    name: '综艺',
    description: '最新最热综艺节目合集，搞笑、音乐、竞技、旅行、美食一网打尽',
    items: [
      {
        id: 301,
        title: '这就是街舞',
        category: '竞技',
        rating: 8.8,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Street%20dance%20show%20poster%2C%20dynamic%20dancer%20with%20urban%20graffiti%20background%2C%20vibrant%20neon%20colors%2C%20energetic%20composition&width=600&height=800&seq=cat-var-01&orientation=portrait',
        description: '顶尖舞者集结，用热血与热爱点燃舞台，展现街舞的无限魅力。',
      },
      {
        id: 302,
        title: '奔跑吧兄弟',
        category: '户外',
        rating: 8.2,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20outdoor%20adventure%20theme%2C%20bright%20sunny%20atmosphere%2C%20fun%20and%20energetic%20group%20composition&width=600&height=800&seq=cat-var-02&orientation=portrait',
        description: '明星嘉宾们在户外展开一系列趣味挑战，笑料不断，欢乐升级。',
      },
      {
        id: 303,
        title: '向往的生活',
        category: '生活',
        rating: 8.6,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20rural%20life%20variety%20show%20poster%2C%20countryside%20farmhouse%2C%20green%20fields%2C%20warm%20pastoral%20atmosphere%2C%20relaxing%20composition&width=600&height=800&seq=cat-var-03&orientation=portrait',
        description: '回归田园生活，自给自足，与好友共享宁静惬意的慢生活时光。',
      },
      {
        id: 304,
        title: '歌手2024',
        category: '音乐',
        rating: 8.5,
        year: 2024,
        image: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%2C%20stage%20with%20spotlight%2C%20microphone%20stand%2C%20dramatic%20dark%20background%20with%20golden%20lighting&width=600&height=800&seq=cat-var-04&orientation=portrait',
        description: '华语乐坛顶级歌手同台竞演，用歌声诠释音乐的力量与魅力。',
      },
      {
        id: 305,
        title: '极限挑战',
        category: '户外',
        rating: 8.4,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20challenge%20variety%20show%20poster%2C%20urban%20adventure%2C%20challenging%20missions%2C%20dynamic%20group%20action%2C%20bold%20colors&width=600&height=800&seq=cat-var-05&orientation=portrait',
        description: '极限男人帮再次集结，用智慧和勇气完成一系列不可能的任务。',
      },
      {
        id: 306,
        title: '乘风破浪',
        category: '竞演',
        rating: 8.3,
        year: 2024,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20female%20singers%20competition%20show%20poster%2C%20elegant%20stage%20performance%2C%20shimmering%20lights%2C%20empowering%20atmosphere&width=600&height=800&seq=cat-var-06&orientation=portrait',
        description: '30+姐姐们重新出发，用实力证明年龄只是数字，活出最精彩的自己。',
      },
    ],
  },
  anime: {
    name: '动漫',
    description: '热门动漫番剧在线观看，日漫国漫精选，热血战斗、治愈日常、悬疑推理应有尽有',
    items: [
      {
        id: 401,
        title: '鬼灭之刃',
        category: '战斗',
        rating: 9.3,
        year: 2019,
        image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20poster%2C%20sword%20action%20with%20water%20breathing%20effect%2C%20vibrant%20blue%20and%20red%2C%20dynamic%20composition&width=600&height=800&seq=cat-ani-01&orientation=portrait',
        description: '少年炭治郎为救妹妹踏上斩鬼之路，演绎热血与温情的传奇故事。',
      },
      {
        id: 402,
        title: '咒术回战',
        category: '战斗',
        rating: 9.1,
        year: 2020,
        image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20jujutsu%20kaisen%20poster%2C%20dark%20supernatural%20battle%20scene%2C%20cursed%20energy%20visual%2C%20intense%20action&width=600&height=800&seq=cat-ani-02&orientation=portrait',
        description: '高中生虎杖悠仁吞下诅咒之王的手指，开启与诅咒战斗的宿命之旅。',
      },
      {
        id: 403,
        title: '时光代理人',
        category: '悬疑',
        rating: 9.0,
        year: 2021,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20time%20travel%20poster%2C%20mysterious%20clock%20and%20photo%20elements%2C%20modern%20urban%20style%2C%20warm%20and%20cool%20contrast&width=600&height=800&seq=cat-ani-03&orientation=portrait',
        description: '通过照片穿越时空，两个年轻人用特殊能力帮助委托人弥补遗憾。',
      },
      {
        id: 404,
        title: '葬送的芙莉莲',
        category: '冒险',
        rating: 9.4,
        year: 2023,
        image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20fantasy%20adventure%20poster%2C%20elf%20mage%20journey%2C%20beautiful%20fantasy%20landscape%2C%20melancholy%20atmosphere&width=600&height=800&seq=cat-ani-04&orientation=portrait',
        description: '勇者小队击败魔王后，长寿的精灵魔法使芙莉莲开始了理解生命的旅程。',
      },
      {
        id: 405,
        title: '雾山五行',
        category: '国漫',
        rating: 9.2,
        year: 2020,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20martial%20arts%20poster%2C%20ink%20wash%20painting%20style%2C%20elemental%20powers%2C%20five%20elements%20theme%2C%20dynamic%20battle%20scene&width=600&height=800&seq=cat-ani-05&orientation=portrait',
        description: '五行之力与妖兽的殊死搏斗，中国水墨画风与热血战斗的完美融合。',
      },
      {
        id: 406,
        title: '间谍过家家',
        category: '喜剧',
        rating: 8.9,
        year: 2022,
        image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20spy%20family%20comedy%20poster%2C%20fun%20family%20scene%2C%20retro%20European%20style%2C%20warm%20and%20playful%20atmosphere&width=600&height=800&seq=cat-ani-06&orientation=portrait',
        description: '间谍、杀手、超能力者组成的伪装家庭，上演温馨又爆笑的日常。',
      },
      {
        id: 407,
        title: '凡人修仙传',
        category: '国漫',
        rating: 8.8,
        year: 2020,
        image: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%2C%20immortal%20cultivation%20theme%2C%20ancient%20Chinese%20fantasy%2C%20misty%20mountain%20scene&width=600&height=800&seq=cat-ani-07&orientation=portrait',
        description: '一个普通山村少年韩立，凭借智慧和毅力踏上修仙之路的传奇故事。',
      },
      {
        id: 408,
        title: '进击的巨人',
        category: '战斗',
        rating: 9.5,
        year: 2013,
        image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20attack%20on%20titan%20poster%2C%20giant%20titan%20and%20soldiers%2C%20epic%20battle%2C%20dark%20apocalyptic%20atmosphere&width=600&height=800&seq=cat-ani-08&orientation=portrait',
        description: '人类与巨人的惨烈战争，少年艾伦为自由奋起反抗的史诗级故事。',
      },
    ],
  },
};